import { combineReducers } from "redux";

const initialState = {};
const editRejectedInitialState = {
  editReject: []
};
// const initialState = {
//   editReject: []
// };

function correctionReducer(state = initialState, action) {
  // Handle different actions and update the state accordingly
  if (action.type === "EDIT") {
    return { ...state, corrections: action.payload };
  }

  // Add more cases for your specific actions
  else {
    return state;
  }
}


function homefeatures(state = "Advantages", action) {
  if (action.type === "setfeature") {
    return state = action.payload
  } else {
    return state
  }
}


function EditToolReducer(state = initialState, action) {

  if (action.type === "EDITTOOL") {
    console.log("data coming to the EditToolReducer function type EDITTOOL is :", action.payload)
    //clean the editcorrections into new to set new corrections
    if (!action.payload.data) {

      return {
        ...state,
        EditCorrections: {}
      }
    }
    //need to pass the key and data what are the things we are going to update
    return {
      ...state,
      EditCorrections: {
        ...state.EditCorrections,
        [action.payload.key]: action.payload.data

      }
    };
  }

  else if (action.type === "TOOLUPDATE") {

    const { [action.payload.key]: _, ...rest } = state.EditCorrections;
    return {
      ...state,
      EditCorrections: rest
    };
  }
  else {
    return state;
  }
}


function queriesReducer(state = initialState, action) {
  if (action.type === "QueryEdit") {
    return { ...state, queries: action.payload };
  } else {
    return state;
  }
}

function UploadTexFile(state = initialState, action) {
  if (action.type === "UploadTex") {
    return { ...state, tex: action.payload };
  } else {
    return state;
  }
}


const autoSuggestionInitialState = {
  suggestions: [],
  isChecked: true,
  autoapply: false,
  triggerToolStyles: false,
  pendingAIEdit: null,

};

function autoSuggestion(state = autoSuggestionInitialState, action) {
  if (action.type === "setPendingAIEdit") {
    return { ...state, pendingAIEdit: action.payload };
  }
  else if (action.type === "clearPendingAIEdit") {
    return { ...state, pendingAIEdit: null };
  }
  else if (action.type === "addAutoSuggestion") {
    const existingIds = new Set(state.suggestions.map(s => s.id));
    const newItems = action.payload.filter(s => !existingIds.has(s.id));
    return { ...state, suggestions: [...state.suggestions, ...newItems] };
  }

  else if (action.type === "removeAutoSuggestion") {
    const toRemove = action.payload;
    return {
      ...state,
      suggestions: state.suggestions.filter(item =>
        item.id && toRemove.id
          ? item.id !== toRemove.id
          : !(item.startAnchor?.row === toRemove.startAnchor?.row &&
            item.startAnchor?.column === toRemove.startAnchor?.column)
      )
    };
  }
  else if (action.type === "removeStaleAutoSuggestions") {
    const staleSet = new Set(action.payload);
    return { ...state, suggestions: state.suggestions.filter(s => !staleSet.has(s.id)) };
  }

  else if (action.type === "clearAutoSuggestion") {
    return {
      ...state,
      suggestions: []
    };
  } else if (action.type === "changeIsChecked") {
    return {
      ...state,
      isChecked: !state.isChecked
    }
  } else if (action.type === "onIsChecked") {
    return {
      ...state,
      isChecked: true
    }
  } else if (action.type === "offIsChecked") {
    return {
      ...state,
      isChecked: false
    }
  } else if (action.type === "autoapplyonoff") {
    return {
      ...state,
      autoapply: !state.autoapply
    }
  } else if (action.type === "triggerToolStyles") {
    return {
      ...state,
      triggerToolStyles: !state.triggerToolStyles
    }
  }

  else {
    return state;
  }
}

function EditRejected(state = {
  editReject: [],
  autoSuggestionReject: [], // Separate rejection list for auto suggestions
  showSuggestion: true,
  showautosuggestion: false,
  isLoadingSuggestion: false,
  clearAllTrigger: false,
}, action) {
  if (action.type === "AddReject") {
    console.log("data coming to the AddReject is:", action.payload);
    return {
      ...state,
      editReject: [...state.editReject, ...action.payload],
    };
  } // YOUR CURRENT REDUCER — wrong dedup check
  else if (action.type === "AddAutoSuggestionReject") {
    const already = state.autoSuggestionReject.some(r => r.id === action.payload.id);
    if (already) return state;
    return { ...state, autoSuggestionReject: [...state.autoSuggestionReject, action.payload] };
  } else if (action.type === "EmptyReject") {
    return {
      ...state,
      editReject: []
    };
  } else if (action.type === "EmptyAutoSuggestionReject") {
    return {
      ...state,
      autoSuggestionReject: []
    };
  } else if (action.type === "showsuggestion") {
    return {
      ...state,
      showSuggestion: true
    }
  } else if (action.type === "Dontshowsuggestion") {
    return {
      ...state,
      showSuggestion: false
    }

  } else if (action.type === "toggleautosuggestion") {
    return {
      ...state,
      showautosuggestion: !state.showautosuggestion
    }
  } else if (action.type === "StartLoadingSuggestion") {
    return {
      ...state,
      isLoadingSuggestion: true,
    }
  } else if (action.type === "stopLoadingSuggestion") {
    return {
      ...state,
      isLoadingSuggestion: false,
    }
  } // In your reducer
  else if (action.type === "triggerClearAll") {
    return {
      ...state,
      clearAllTrigger: !state.clearAllTrigger  // toggle to fire useEffect
    }
  }

  else {
    return state;
  }
}
function editorJumpReducer(state = { editorJump: null }, action) {
  switch (action.type) {
    case "editorJump":
      return { ...state, editorJump: action.payload };
    default:
      return state;
  }
}




function latexSearchText(state = initialState, action) {
  if (action.type === "latexSearch") {
    return { ...state, latexSearch: action.payload };
  } else {
    return state;
  }
}

function pdfSearchText(state = initialState, action) {

  if (action.type === "pdfSearch") {
    return { ...state, pdfSearch: action.payload };
  } else {
    return state;
  }
}

function toolsSelection(state = initialState, action) {
  if (action.type === "toolSearch") {
    return { ...state, toolSearch: action.payload };
  } else {
    return state;
  }
}

function setClientWidth(state = initialState, action) {
  if (action.type === "clientwidth") {
    return { ...state, clientwidth: action.payload };
  } else {
    return state;
  }
}

function setDragging(state = initialState, action) {
  if (action.type === "dragging") {
    return { ...state, dragging: action.payload };
  } else {
    return state;
  }
}

function selectEplStyles(state = initialState, action) {
  if (action.type === "Submit") {

    return { ...state, function: action.payload };
  } else {
    return state;
  }
}

function selectEditStyles(state = initialState, action) {
  console.log("state in the selected Editstyles", state)
  if (action.type === "ToolSubmit") {

    if (!action.payload.key) {

      return {
        ...state,
        function: {},
        isChecked: action.payload.isChecked
      }
    }

    return {
      ...state, function: {
        [action.payload.key]: action.payload.data
      }, isChecked: action.payload.isChecked
    };
    //setting like key:value -> epl:['Removecommands'] and is checked true 

  }
  else if (action.type === "ToolRejected") {
    const existingData = state.function[action.payload.key] || [];


    const filteredData = existingData.filter(
      (item) => action.payload.data !== item)

    return {
      ...state,
      function: {
        ...state.function,
        [action.payload.key]: filteredData,
      },
    };
  } else {
    return state;
  }
}
//MARK:Toggle project
const projectModeInitialState = {
  projectMode: false
};
function toggleProjectMode(state = projectModeInitialState, action) {
  if (action.type === "projectMode") {
    return { ...state, projectMode: action.payload };
  } else {
    return state;
  }
}
function compileTex(state = initialState, action) {
  if (action.type === "compile") {
    return { ...state, compile: action.payload };
  } else {
    return state;
  }
}
function trackCompile(state = initialState, action) {
  if (action.type === "trackcompile") {
    return { ...state, trackcompile: action.payload };
  } else {
    return state;
  }
}
//state for Trigger shortcut
const compileTexIntial = {
  compileTrigger: false
};
function compileTrigger(state = compileTexIntial, action) {
  switch (action.type) {
    case "TRIGGER_COMPILE":
      return { ...state, compileTrigger: true };
    case "RESET_COMPILE":
      return { ...state, compileTrigger: false };
    default:
      return state;
  }
}

const compileTrackInitial = {
  compileTrackTrigger: false
};
function compileTrackTrigger(state = compileTrackInitial, action) {
  switch (action.type) {
    case "TRIGGER_TRACK_COMPILE":
      return { ...state, compileTrackTrigger: true };
    case "RESET_TRACK_COMPILE":
      return { ...state, compileTrackTrigger: false };
    default:
      return state;
  }
}

function LoadSuggestions(state = initialState, action) {
  if (action.type === "TriggerSuggestions") {
    return { ...state, SuggestionTrigger: action.payload }
  } else {
    return state;
  }
}



// function EditRejected(state = editRejectedInitialState, action) {
//   //in the suggestion edit we can add rejections
//   if (action.type === "AddReject") {
//     console.log("data coming to the ADDReject is :", action.payload, action.payload.key)
//     return {
//       ...state,
//       editReject: [...state.editReject, ...action.payload],
//     };
//   } else if (action.type === "EmptyReject") {
//     return { ...state, editReject: [] };
//   }
//   else {
//     return state;
//   }
// }

function clientSelect(state = {
  clientSelect: "",
  changeclient: false
}, action) {
  if (action.type === "clientselect") {
    return { ...state, clientselect: action.payload }
  } else if (action.type === "changeclient") {
    return {
      ...state,
      changeclient: !state.changeclient
    }
  }

  else {
    return state;
  }
}

function updateCorrections(state = initialState, action) {
  if (action.type === "accept") {
    return { ...state, corrections: action };
  } else if (action.type === "reject") {
    return { ...state, corrections: action };
  } else {
    return state;
  }
}

function updateToolCorrections(state = initialState, action) {
  if (action.type === "ToolAccept") {
    console.log("the action in accepting is :", action);
    console.log("accepting style is :", action)
    return { ...state, corrections: action };
  } else if (action.type === "ToolReject") {
    console.log("the action in rejecting is :", action);

    return { ...state, corrections: action };
  } else {
    return state;
  }
}

function EnvironmentTrigger(state = { envTrigger: false }, action) {
  switch (action.type) {
    case "Triggered":
      return { ...state, envTrigger: !state.envTrigger };
    default:
      return state;
  }
}
// function enableOnChange(state = initialState, action) {
//   if(action.type === "onChange"){
//     console.log("reached reducer");
//     console.log(action.payload);
//     return {...state, currentstate: action.payload }
//   }else{
//     return state;
//   }
// }
const rootReducer = combineReducers({
  correction: correctionReducer, // reducer for correction update's
  EditTool: EditToolReducer,
  queries: queriesReducer, // reducer for query update's
  uploadTex: UploadTexFile, // reducer for texfile for compilation
  latexsearch: latexSearchText, // reducer for searching text in editor
  pdfsearch: pdfSearchText, // reducer for searching text in PDF
  toolsearch: toolsSelection, // reducer for searching the tools output in editor.
  clientwidth: setClientWidth,
  dragging: setDragging,
  eplStyles: selectEplStyles,
  editToolRejected: EditRejected,
  toolStyles: selectEditStyles,
  // submitAction: enableOnChange,
  projectMode: toggleProjectMode,
  compileTex: compileTex,
  trackCompile: trackCompile,
  LoadSuggestions: LoadSuggestions,
  compileTrig: compileTrigger,
  compileTrackTrig: compileTrackTrigger,
  homefeatures: homefeatures,
  updateCorrections: updateCorrections,
  updateToolCorrections: updateToolCorrections,
  clientSelect: clientSelect,
  EnvironmentTrigger: EnvironmentTrigger,
  autoSuggestion: autoSuggestion,
  editorjump: editorJumpReducer,
});

export default rootReducer;
